import React, { useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { List, Divider, Typography, Button } from "@material-ui/core";
import { Link, NavLink } from "react-router-dom";
import { push } from "../../../router/history";
import {
  AddToQueue,
  Storage,
  People,
  Web,
  ContactMail,
  LocalMall,
  ExitToApp,
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  divRow: {
    display: "flex",
    flexDirection: "row",
  },
  inactive: {
    color: "#141b2f",
    textDecoration: "none",
  },
  active: {
    color: "blue",
    fontWeight: "bold",
    textDecoration: "none",
  },
  icon: {
    marginRight: 10,
  },
  list: {
    "&:hover": {
      background: "#dcdcdc",
    },
  },
}));

const OptionsDrawer = (props) => {
  const classes = useStyles();
  return (
    <div>
      {props.user.group.name === "Administrador" ? (
        <div style={{ marginLeft: 5 }}>
          <List className={classes.list}>
            <NavLink
              className={classes.inactive}
              activeClassName={classes.active}
              to="/user-list"
            >
              <div className={classes.divRow}>
                <People className={classes.icon} />
                <Typography>Usuários</Typography>
              </div>
            </NavLink>
          </List>
          <Divider />
          <List className={classes.list}>
            <NavLink
              className={classes.inactive}
              activeClassName={classes.active}
              to="/powerbi"
            >
              <div className={classes.divRow}>
                <Web className={classes.icon} />
                <Typography>Telas</Typography>
              </div>
            </NavLink>
          </List>
          <Divider />
          <List className={classes.list}>
            <NavLink
              className={classes.inactive}
              activeClassName={classes.active}
              to="/user-create"
            >
              <div className={classes.divRow}>
                <ContactMail className={classes.icon} />
                <Typography>Cadastrar Usuário</Typography>
              </div>
            </NavLink>
          </List>

          <Divider />
          <List className={classes.list}>
            <NavLink
              className={classes.inactive}
              activeClassName={classes.active}
              to="/register-department"
            >
              <div className={classes.divRow}>
                <LocalMall className={classes.icon} />
                <Typography>Cadastrar setor</Typography>
              </div>
            </NavLink>
          </List>
          <Divider />
          <List className={classes.list}>
            <NavLink
              className={classes.inactive}
              activeClassName={classes.active}
              to="/register-bi"
            >
              <div className={classes.divRow}>
                <AddToQueue className={classes.icon} />
                <Typography>Cadastrar Tela</Typography>
              </div>
            </NavLink>
          </List>
          <Divider />
          <List className={classes.list}>
            <NavLink
              className={classes.inactive}
              activeClassName={classes.active}
              to="/logs"
            >
              <div className={classes.divRow}>
                <Storage className={classes.icon} />
                <Typography>Logs</Typography>
              </div>
            </NavLink>
          </List>
          <Divider />
          <List className={classes.list}>
            <NavLink
              className={classes.inactive}
              //activeClassName={classes.active}
              to="/"
              onClick={() => {
                localStorage.removeItem("@jarvis/token");
                localStorage.removeItem("@jarvis/user");
              }
              }
            >
              <div className={classes.divRow}>
                <ExitToApp className={classes.icon} />
                <Typography>Sair</Typography>
              </div>
            </NavLink>
          </List>
          <Divider />
        </div>
      ) : (
        <div>
          <List className={classes.list}>
            <NavLink
              className={classes.inactive}
              activeClassName={classes.active}
              to="/powerbi"
            >
              <div className={classes.divRow}>
                <Web />
                <Typography>Telas</Typography>
              </div>
            </NavLink>
          </List>
          <Divider />
        </div>
      )}
    </div>
  );
};

export default OptionsDrawer;
